var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4276 12.5692H12.999V6.49777C12.999 3.97813 11.1365 1.89598 8.71331 1.54955V0.854911C8.71331 0.460268 8.39367 0.140625 7.99902 0.140625C7.60438 0.140625 7.28474 0.460268 7.28474 0.854911V1.54955C4.86152 1.89598 2.99902 3.97813 2.99902 6.49777V12.5692H2.57045C2.25438 12.5692 1.99902 12.8246 1.99902 13.1406V13.7121C1.99902 13.7906 2.06331 13.8549 2.14188 13.8549H5.99902C5.99902 14.9585 6.89545 15.8549 7.99902 15.8549C9.1026 15.8549 9.99902 14.9585 9.99902 13.8549H13.8562C13.9347 13.8549 13.999 13.7906 13.999 13.7121V13.1406C13.999 12.8246 13.7437 12.5692 13.4276 12.5692ZM7.99902 14.7121C7.52581 14.7121 7.14188 14.3281 7.14188 13.8549H8.85617C8.85617 14.3281 8.47224 14.7121 7.99902 14.7121ZM4.28474 12.5692V6.49777C4.28474 5.50491 4.67045 4.57277 5.37224 3.87098C6.07402 3.1692 7.00617 2.78348 7.99902 2.78348C8.99188 2.78348 9.92402 3.1692 10.6258 3.87098C11.3276 4.57277 11.7133 5.50491 11.7133 6.49777V12.5692H4.28474Z",
    fill: "#0c3255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.9b0f1255ea01311d1d2da030dd531e07.svg";
export { ForwardRef as ReactComponent };